import React, { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { HiX } from "react-icons/hi";
import { useLayout } from "../contexts/layoutContext";
import { MORE_MENU_ITEMS, isRouteActive } from "../config/navigation";
import "./MobileMoreMenu.css";

const MobileMoreMenu = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { moreMenuOpen, closeMoreMenu } = useLayout();

  useEffect(() => {
    if (!moreMenuOpen) return undefined;

    const onKeyDown = (e) => {
      if (e.key === "Escape") closeMoreMenu();
    };

    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [moreMenuOpen, closeMoreMenu]);

  if (!moreMenuOpen) return null;

  const handleNavigate = (route) => {
    navigate(route);
    closeMoreMenu();
  };

  return (
    <div className="mobile-more-root" role="presentation">
      <button
        type="button"
        className="mobile-more-backdrop"
        aria-label="Cerrar menú"
        onClick={closeMoreMenu}
      />

      <div
        className="mobile-more-sheet"
        role="dialog"
        aria-modal="true"
        aria-labelledby="mobile-more-title"
      >
        <div className="mobile-more-header">
          <h2 id="mobile-more-title" className="mobile-more-title">
            Todas las secciones
          </h2>
          <button
            type="button"
            onClick={closeMoreMenu}
            aria-label="Cerrar"
            className="mobile-more-close"
          >
            <HiX size={22} />
          </button>
        </div>

        <nav className="mobile-more-grid" aria-label="Menú adicional">
          {MORE_MENU_ITEMS.map((item) => {
            const Icon = item.icon;
            const active = isRouteActive(location.pathname, item.route);

            return (
              <button
                key={item.route}
                type="button"
                onClick={() => handleNavigate(item.route)}
                className={`mobile-more-item ${active ? "mobile-more-item--active" : ""}`}
              >
                <Icon size={26} aria-hidden />
                <span className="mobile-more-item-label">{item.shortLabel || item.label}</span>
              </button>
            );
          })}
        </nav>
      </div>
    </div>
  );
};

export default MobileMoreMenu;
